import React, { useState, useEffect } from 'react';
import { register } from '../../../i18n';
import LessonService from '../../services/LessonService';
import '../../../css/Tools.scss';
import '../../../css/Accessibility.scss';

const t = register('ToolNames');

// Default fallback languages - keys are your app's locale codes,
// WebReaderService.normalizeLanguageCode() converts them to RS format before use
const defaultLanguageNames = {
  'cs-CZ': 'Czech',
  'da-DK': 'Danish',
  'de': 'German',
  'de-DE': 'German (Germany)',
  'de-AT': 'German (Austria)',
  'en': 'English',
  'es': 'Spanish',
  'es-ES': 'Spanish (Spain)',
  'es-AR': 'Spanish (Argentina)',
  'es-MX': 'Spanish (Mexico)',
  'fi-FI': 'Finnish',
  'fr': 'French',
  'fr-FR': 'French (France)',
  'fr-CA': 'French (Canada)',
  'hi-IN': 'Hindi',
  'hu-HU': 'Hungarian',
  'it': 'Italian',
  'ja-JP': 'Japanese',
  'ko-KR': 'Korean',
  'nb-NO': 'Norwegian',
  'nl': 'Dutch',
  'pl-PL': 'Polish',
  'pt': 'Portuguese',
  'pt-BR': 'Portuguese (Brazil)',
  'pt-PT': 'Portuguese (Portugal)',
  'ro-RO': 'Romanian',
  'ru': 'Russian',
  'sk-SK': 'Slovak',
  'sv-SE': 'Swedish',
  'zh-CN': 'Chinese (Simplified)',
  'zh-TW': 'Chinese (Traditional)'
};

const WebReaderLanguageSelector = ({ isOpen, onSelect, onClose, positionStyle }) => {
  const [languageNames, setLanguageNames] = useState(defaultLanguageNames);

  useEffect(() => {
    const fetchLanguages = async () => {
      try {
        const translationLanguages = await LessonService.fetchTranslationLanguages();
        if (translationLanguages) {
          setLanguageNames(translationLanguages);
        }
      } catch (error) {
        console.error('Error fetching translation languages:', error);
        // Keep using default languages on error
      }
    };

    fetchLanguages();
  }, []);

  if (!isOpen) return null;

  const languages = Object.keys(languageNames);

  return (
    <div
      aria-labelledby='webreader-translate-dialog-title'
      className='dropdown-menu-popup open webreader-language-selector'
      role='menu'
      style={positionStyle}
    >
      <div className='selectorBody'>
        <h2 className='title-label basic webreader-language-title' id='webreader-translate-dialog-title'>
          {t('translateTool', 'Select translation language')}
        </h2>
        <div className='control-container webreader-language-list'>
          {languages.map((lang) => (
            <button
              key={lang}
              className='tools-btn webreader-language-button'
              onClick={() => onSelect(lang)}
              type='button'
            >
              {languageNames[lang] || lang}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WebReaderLanguageSelector;

// Export for backward compatibility
export { defaultLanguageNames as languageNames };
